<div class="images-carousel">
  <div
    emblaCarousel
    class="embla"
    [options]="options"
    [subscribeToEvents]="subscribeToEvents"
    (emblaChange)="onEmblaChange($event)"
  >
    <div class="embla__container">
      <ng-container *ngFor="let imageId of imageIds; let imageIndex = index">
        <div class="img-wrapper embla__slide">
          <img [src]="imageId | getImageSrc: 'Product images' : 'middleSize' : productUnionId" />
        </div>
      </ng-container>
    </div>

    <tui-pagination
      *ngIf="isMobile && imageIds.length > 1"
      class="embla__pagination"
      size="s"
      [length]="imageIds.length"
      [(index)]="selectedImgIndex"
      (indexChange)="changeImageIndex($event)"
    ></tui-pagination>
  </div>

  <div *ngIf="isDesktop && imageIds.length > 1" class="embla-thumbs-wrapper">
    <button
      tuiIconButton
      type="button"
      appearance="outline"
      iconStart="@tui.chevron-left"
      [style.border-radius.%]="100"
      [size]="tuiElementMediumSize"
      (click)="navigate(-1)"
    ></button>

    <div #emblaThumbs emblaCarousel [options]="optionsThumbs" class="embla-thumbs">
      <div class="embla-thumbs__container">
        <ng-container *ngFor="let imageId of imageIds; let imageIndex = index">
          <div
            class="img-wrapper embla-thumbs__slide"
            [class.embla-thumbs__slide_disabled]="imageIndex !== selectedImgIndex"
          >
            <img
              [src]="imageId | getImageSrc: 'Product images' : 'thumbnail' : productUnionId"
              (click)="changeImageIndex(imageIndex)"
            />
          </div>
        </ng-container>
      </div>
    </div>

    <button
      tuiIconButton
      type="button"
      appearance="outline"
      iconStart="@tui.chevron-right"
      [style.border-radius.%]="100"
      [size]="tuiElementMediumSize"
      (click)="navigate(1)"
    ></button>
  </div>
</div>
